/* FadCloset — measure-guide.js
   The guide sheet: saves as you type, hands off to the builder, or emails itself.
   Category-aware — same measurement sets as the builder. */
(function () {
  'use strict';

  var form = document.querySelector('[data-guide]');
  if (!form) return;

  var KEY = 'fadcloset:spec';
  var categoryInputs = Array.prototype.slice.call(form.querySelectorAll('[data-guide-category]'));
  var qs = Array.prototype.slice.call(form.querySelectorAll('[data-q]'));
  var progress = form.querySelector('[data-progress]');
  var countEl = form.querySelector('[data-count]');
  var errEl = form.querySelector('[data-error]');
  var bodyEl = form.querySelector('[data-body]');
  var useBtn = form.querySelector('[data-use]');
  var printBtn = form.querySelector('[data-print]');

  var inputs = []; // scoped to the current category's panel
  var currentCategory = form.dataset.defaultCategory || (categoryInputs[0] && categoryInputs[0].value) || 'jacket';

  /* ---------- persistence ---------- */
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; }
    catch (e) { return {}; }
  }

  function save() {
    var existing = read();
    var spec = { category: currentCategory, measures: {}, profile: existing.profile || {}, savedAt: Date.now() };
    inputs.forEach(function (i) { if (i.value) spec.measures[i.dataset.num] = i.value; });
    qs.forEach(function (q) { if (q.value) spec.profile[q.dataset.label] = q.value; });
    try { localStorage.setItem(KEY, JSON.stringify(spec)); } catch (e) { /* private mode — fine */ }
    return spec;
  }

  function setCategory(cat) {
    currentCategory = cat;
    document.querySelectorAll('[data-measure-category]').forEach(function (panel) {
      panel.hidden = panel.dataset.measureCategory !== cat;
    });
    inputs = Array.prototype.slice.call(
      form.querySelectorAll('[data-measure-category="' + cat + '"] [data-measure-input]')
    );
  }

  function restore() {
    var spec = read();
    if (spec.category && categoryInputs.some(function (c) { return c.value === spec.category; })) {
      currentCategory = spec.category;
      categoryInputs.forEach(function (c) { c.checked = (c.value === spec.category); });
    }
    setCategory(currentCategory);

    if (!spec.measures) return;
    inputs.forEach(function (i) {
      if (spec.measures[i.dataset.num]) i.value = spec.measures[i.dataset.num];
    });
    qs.forEach(function (q) {
      if (spec.profile && spec.profile[q.dataset.label]) q.value = spec.profile[q.dataset.label];
    });
  }

  /* ---------- the numbers checking each other ---------- */
  function advisories() {
    var notes = [];
    var get = function (code) {
      var f = inputs.find(function (i) { return i.dataset.short === code; });
      return f && f.value ? parseFloat(f.value) : null;
    };

    var slvR = get('SLV R'), slvL = get('SLV L');
    if (slvR && slvL && Math.abs(slvR - slvL) > 2) {
      notes.push('Your sleeves differ by more than two inches. That happens, but re-check before we cut.');
    }

    var chest = get('CHEST') || get('BUST'), front = get('F CHST'), back = get('BACK');
    if (chest && front && back && Math.abs(chest - (front + back)) > 3) {
      notes.push('Front chest and back width should add up close to the full chest. One of the three is off.');
    }

    var shoulder = get('SHLDR'), hsR = get('HS R'), hsL = get('HS L');
    if (shoulder && hsR && hsL && Math.abs(shoulder - (hsR + hsL)) > 2) {
      notes.push('The two half shoulders should add up to the full shoulder width.');
    }

    var waist = get('WAIST'), hips = get('HIPS');
    if (waist && hips && waist > hips + 6) {
      notes.push('Waist is much larger than hips — worth re-checking.');
    }
    return notes;
  }

  function refresh() {
    var done = inputs.filter(function (i) { return i.value !== '' && i.checkValidity(); }).length;
    if (progress) progress.style.width = (inputs.length ? Math.round((done / inputs.length) * 100) : 0) + '%';
    if (countEl) countEl.textContent = done + ' of ' + inputs.length + ' measured';

    var notes = advisories();
    if (notes.length) {
      errEl.textContent = 'Check: ' + notes[0];
      errEl.classList.add('is-shown');
    } else {
      errEl.classList.remove('is-shown');
    }

    if (useBtn) useBtn.disabled = done < inputs.length;
    save();
  }

  /* ---------- the printed sheet, as text ---------- */
  function sheet() {
    var profile = read().profile || {};
    var lines = ['MEASUREMENT SHEET — ' + new Date().toLocaleDateString(), 'Category: ' + currentCategory, ''];
    qs.forEach(function (q) { lines.push(q.dataset.label + ': ' + (q.value || '—')); });
    Object.keys(profile).forEach(function (label) { lines.push(label + ': ' + profile[label]); });
    lines.push('', 'MEASUREMENTS (inches)');
    inputs.forEach(function (i) {
      lines.push(i.dataset.num + '. ' + i.dataset.label + ': ' + (i.value || '—'));
    });
    var notes = advisories();
    if (notes.length) lines.push('', 'FLAGGED: ' + notes.join(' '));
    return lines.join('\n');
  }

  form.addEventListener('input', refresh);
  form.addEventListener('change', function (e) {
    if (e.target.matches('[data-guide-category]')) setCategory(e.target.value);
    refresh();
  });

  form.addEventListener('submit', function () {
    if (bodyEl) bodyEl.value = sheet();
  });

  if (useBtn) {
    useBtn.addEventListener('click', function () {
      save();
      var returnUrl = new URLSearchParams(window.location.search).get('return_url');
      var target = returnUrl ? decodeURIComponent(returnUrl) : useBtn.dataset.target;
      var sep = target.indexOf('?') === -1 ? '?' : '&';
      window.location.href = target + sep + 'spec=saved&category=' + encodeURIComponent(currentCategory);
    });
  }

  if (printBtn) {
    printBtn.addEventListener('click', function () { window.print(); });
  }

  restore();
  refresh();
})();
